import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Label',
  props: {
  top: {
    type: String,
    required: true,
  },
  left: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const style = computed(() => {
  return {
    position: "absolute",
    top: props.top,
    left: props.left,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "label",
    style: _normalizeStyle(style.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4 /* STYLE */))
}
}

})